export default __webpack_public_path__ + "static/media/investor.81ce16ac.svg";